import { getParamValue } from "@pepsico/pref-permissions";

import { GROWER_PREF_KEY, SITE_PREF_KEY, TRIAL_PREF_KEY } from "defs";

export const readSelectedGeoId =
  (prefKey: string) =>
  (
    prefs: Record<string, string | string[]>,
    availableIds: readonly number[],
  ): number | null => {
    const stored = getParamValue(prefs, prefKey);
    if (stored == null || stored === "") {
      return null;
    }

    const id = Number(stored);
    return availableIds.includes(id) ? id : null;
  };

/** Stored grower id, or null when unset or not a grower at this location. */
export const readSelectedGrowerGeoId = readSelectedGeoId(GROWER_PREF_KEY);

/** Stored site id, or null when unset or not a site at this location. */
export const readSelectedSiteGeoId = readSelectedGeoId(SITE_PREF_KEY);

/** Stored trial id, or null when unset or not a trial at this location. */
export const readSelectedTrialGeoId = readSelectedGeoId(TRIAL_PREF_KEY);
